module.exports = require('./helpers/bundle-url').getBundleURL('lABAT') + "logo-dark.eefe0b7f.svg";